import { ClubAmenity } from "@app/core/community/domain/model/club-amenity";
import { ClubEvent } from "@app/core/community/domain/model/club-event";

export class CommunityClub {
  constructor(
    readonly id: string,
    readonly name: string,
    readonly city: string,
    readonly country: string,
    // Deferred: not returned by the API yet — always ""
    readonly neighborhood: string,
    readonly address: string,
    // Nullable: API marks these as nullable
    readonly imageUrl: string | null,
    readonly coverImageUrl: string | null,
    // Deferred: dropped in #678 discussion — always 0
    readonly rating: number,
    readonly reviewsCount: number,
    readonly membersCount: number | null,
    readonly courtsCount: number | null,
    // Nullable: only set when lat/lng are provided in the request
    readonly distanceKm: number | null,
    // Deferred: not returned by the API yet
    readonly isFeatured: boolean,
    readonly isOpenNow: boolean,
    readonly openingHoursText: string,
    readonly nextAvailableText: string | null,
    readonly priceRangeText: string,
    readonly amenities: ClubAmenity[],
    // Derived: courts_aiball_count > 0
    readonly hasAiballService: boolean,
    readonly latitude: number,
    readonly longitude: number,
    // Nullable: optional contact info
    readonly phone: string | null,
    readonly website: string | null,
    readonly googleMapsLink: string | null,
    // Deferred: not returned by the API yet
    readonly events: ClubEvent[],
    readonly allCourtsSacraActive: boolean,
    readonly isFavorite: boolean = false,
  ) {}
}

export enum CommunityClubSortBy {
  DISTANCE = "DISTANCE",
  RATING = "RATING",
  NAME = "NAME",
}
